import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "NEMA_5-15P",
  "use": "NEMA_5-15P-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"NEMA_5-15P\"><path d=\"M20 38.5c10.217 0 18.5-8.283 18.5-18.5S30.217 1.5 20 1.5 1.5 9.783 1.5 20 9.783 38.5 20 38.5zm0 1.5C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zM15 5h10v8a5 5 0 01-10 0V5zm1.5 1.5V13a3.5 3.5 0 007 0V6.5h-7zM9 16h5v13H9V16zm1.5 1.5v10h2v-10h-2zM26 19h5v10h-5V19zm1.5 1.5v7h2v-7h-2z\" fill=\"#000\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol